export default {
  pending: false,
  list: []
};
